import * as React from "react";
import { Menu } from "lucide-react";
import { ORGANIZATION_MODULES, APP_NAME } from "@/lib/constants";
import { NavItem } from "@/components/layout/NavItem";
import { OrgSwitcher } from "@/components/layout/OrgSwitcher";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { useLanguage } from "@/contexts/LanguageContext";

export function MobileNav() {
  const [open, setOpen] = React.useState(false);
  const { t } = useLanguage();

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="lg:hidden" aria-label={t("Open navigation")}>
          <Menu className="h-5 w-5" />
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="flex flex-col">
        <div className="flex h-16 items-center gap-2 border-b border-border px-4">
          <span className="font-display text-base font-semibold">{APP_NAME}</span>
        </div>
        <div className="px-3 pt-3">
          <OrgSwitcher />
        </div>
        <nav className="flex-1 space-y-0.5 overflow-y-auto px-3 py-4" aria-label="Primary">
          {ORGANIZATION_MODULES.map((module) => (
            <NavItem key={module.path} module={module} onNavigate={() => setOpen(false)} />
          ))}
        </nav>
      </SheetContent>
    </Sheet>
  );
}
